import React, { useEffect, useState, useRef} from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/LoginPage.css";
import logo from "../../../assets/icons/NewLogo.png";
//import tnc from "../../../assets/docs/PraSha-Sync-terms-of-use.html";
//import privpolicy from "../../../assets/docs/PraSha-Sync-Privacy-Policy.html";
import { AuthServices } from "../services/AuthServices";
import GoogleAuth from "../../../shared/utils/GoogleAuth";
import { OverlayService } from "../../home/service/OverlayService";
//import GoogleCustomButton from "../../../shared/utils/GoogleCustomButton";
//import GoogleAuthWithModal from "../../../shared/utils/GoogleAuthWithModal";

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [localStorageEmail, setLocalStorageEmail] = useState(null);
  const [show, setShow] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const lastCountedIdRef = useRef(null);
  const [showTermsModal, setShowTermsModal] = useState(false);   // ✅ add this
  const [showPrivacyModal, setShowPrivacyModal] = useState(false); // ✅ add this
  const [showGoogleOverlay, setShowGoogleOverlay] = useState(false);
  const [showGoogleModal, setShowGoogleModal] = useState(false);
  const [showOTPsend, setShowOTPsend] = useState(false);
  const googleLoginRef = useRef(null); // ref to trigger Google login

  // Add this state at the top of LoginPage
const [showGoogleButton, setShowGoogleButton] = useState(false);


// Add this handler
const handleGoogleClick = () => {
  setShowGoogleButton(true);

  // Trigger GoogleAuth if it exposes a start method
  if (googleLoginRef.current?.start) {
    googleLoginRef.current.start();
  }
};


  const handleEmailLogin = async () => {
    const trimmedEmail = email.trim();
    const isEmpty = trimmedEmail === "";
    const isInvalidFormat = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);

    if (isEmpty || isInvalidFormat) {
      setEmailError(true);
      return;
    }
      
    try {
      setShowOTPsend("Sending OTP to your email  "+trimmedEmail);
      await AuthServices.sendOtp({ email: trimmedEmail });
      localStorage.setItem("email", trimmedEmail);
      setLocalStorageEmail(trimmedEmail);
      setEmailError(false);
      setIsOtpSent(true);
      setShowResend(false);
      setShowOTPsend(false);
     // console.log(`OTP sent to: ${trimmedEmail}`);
      setTimeout(() => setShowResend(true), 15000);
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return alert("Enter a 6-digit code");

    try {
      setShowOTPsend("Authenticating your account securely.");
      const response = await AuthServices.verifyOtp({
        email: localStorageEmail,
        otp,
        role: "LOGIN",
      });
      if (response.status !== 200) {
        return alert("Invalid OTP. Please try again.");
      }
      localStorage.setItem("lastActivityAt", String(Date.now()));
      localStorage.setItem("expertReplyCount", "0");
      localStorage.setItem("userlogin", 'OTP');
      lastCountedIdRef.current = null;
      localStorage.removeItem("lastCountedMsgId");
      let conversationId = localStorage.getItem("conversation_id");
  
      if (!conversationId) {
        
          const response = await OverlayService.createNewSession();
          conversationId = response?.data?.conversation_id;

          if (conversationId) {
            localStorage.setItem("conversation_id", conversationId);
            console.log("🔹 New session created:", conversationId);
          }
        } else {
        console.log("✅ Existing session found:", conversationId);
      }

      setShowOTPsend(false);
      navigate("/home");
    } catch (error) {
      return console.error("Error verifying OTP:", error);
    }
  };

  const handleGoogleStart = () => console.log("Google login started");
  /*
  const handleGoogleStart = () => {
  setShowGoogleOverlay(true);

  // Detect if popup is closed without logging in
  const checkFocus = () => {
    setTimeout(() => {
      if (document.hasFocus()) {
        // User came back without completing login
        setShowGoogleOverlay(false);
        window.removeEventListener("focus", checkFocus);
      }
    }, 1000);
  };

  window.addEventListener("focus", checkFocus);
};
*/

  const sendOTP = async (emailToUse) => {
    try {
      const response = await AuthServices.sendOtp({ email: emailToUse });
      if (response.status === 200) {
        console.log("OTP sent successfully");
      } else {
        console.error("Failed to send OTP:", response);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timeout);
  }, []);


  

  /*
  useEffect(() => {
    const initSession = async () => {
      let conversationId = localStorage.getItem("conversation_id");
  
      if (!conversationId) {
        try {
          const response = await OverlayService.createNewSession();
          conversationId = response?.data?.conversation_id;
          if (conversationId) {
            localStorage.setItem("conversation_id", conversationId);
            console.log("🔹 New session created:", conversationId);
          }
        } catch (err) {
          console.error("❌ Failed to create session:", err);
        }
      } else {
        console.log("✅ Existing session found:", conversationId);
      }
    };
  
    initSession();
  }, []);
  */

 
  return (
    <div className="login-page">
      <div className="top-logo">
        <img src={logo} alt="PrashaSync Logo" className="login-logo" />
      </div>
      <div className={`login-card ${show ? "show" : ""}`}>
        {!isOtpSent ? (
          <>
            
            <h2 className="login-title">Login</h2>
            <input
              type="email"
              className={`email-input ${emailError ? "input-error" : ""}`}
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailError) setEmailError(false);
              }}
            />
            {emailError && (
              <p
                style={{ color: "#e03131", fontSize: "13px", marginTop: "6px" }}
              >
                Please enter a valid email address.
              </p>
            )}
            <button className="continue-button" onClick={handleEmailLogin} disabled={!isChecked}>
              Continue
            </button>

            <div className="separator">
              <span className="or-text">or</span>
            </div>

          <div style={{ position: "relative", display: "inline-block", width: "100%" }}
            onMouseEnter={() => setShowGoogleButton(true)} // hide custom button on hover
            onMouseLeave={() => setShowGoogleButton(false)}  // show it again when leaving
          
          >
  {/* Custom Google Button overlay */}
  {!showGoogleButton && (
    <button
      className="continue-button-google"
      onClick={handleGoogleClick}
      disabled={!isChecked}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 10,
        cursor: !isChecked ? "not-allowed" : "pointer",
        opacity: !isChecked ? 0.8 : 1,
        pointerEvents: !isChecked ? "none" : "auto", // ensures disabled works
        backgroundColor: !isChecked ? "#ccc" : "#744BFC", 
      }}
    >
      Sign-in with Google
    </button>
  )}

  {/* Actual GoogleAuth button */}
  <GoogleAuth
    ref={googleLoginRef}
    disabled={!isChecked} 
    onStart= {() => setShowGoogleOverlay(true)}
    OnClick= {() => console.log("google Onclick")}
    style={{
      opacity: showGoogleButton ? 1 : 0,
      pointerEvents: showGoogleButton ? "auto" : "none",
      width: "100%",
    }}
  />
</div>

  
            {/* <input
              type="checkbox"
              id="agree"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <p className="terms-text">
              By continuing you agree to <a href="https://prashauploadimages.blob.core.windows.net/docs/PraSha%20Sync%20terms%20of%20use.pdf " target="_blank" rel="noopener noreferrer">Terms of Service</a> and{" "}
              <a href="https://prashauploadimages.blob.core.windows.net/docs/PraShaSync%20privacy%20policy.pdf " target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p> */}
            <div className="terms-container">
              <input
                type="checkbox"
                id="agree"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <p className="terms-text">
                By continuing you agree to{" "}
                <span                  
                  onClick={() => setShowTermsModal(true)}
                >
                  Terms of Service
                </span>{" "}
                and{" "}
                <span
                 onClick={() => setShowPrivacyModal(true)}
                >
                  Privacy Policy
                </span>.
              </p>
            </div>
          </>
        ) : (

          
          <>
          
            <h3 className="otp-title">Check your inbox</h3>
            <p className="otp-subtext">
              Enter the 6-digit code we sent to <strong>{email}</strong> to
              finish your login.
            </p>
            <input
              type="text"
              className={`email-input ${otpError ? "input-error" : ""}`}
              placeholder="6-digit code"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value);
                if (otpError) setOtpError(false);
              }}
              maxLength={6}
            />
            {otpError && (
              <p
                style={{ color: "#e03131", fontSize: "13px", marginTop: "6px" }}
              >
                Please enter a valid 6-digit code.
              </p>
            )}

            <button className="continue-button" onClick={handleVerifyOtp}>
              Login
            </button>
            <p
              className={`resend-code ${!showResend ? "disabled" : ""}`}
              onClick={showResend ? handleEmailLogin : undefined}
            >
              Resend code
            </p>

          </>
        )}

{showOTPsend && (

<div className="modal-overlay-google">
        <div className="modal-box-google">
      <img
        src={logo}
        alt="Prashasync Logo"
        className="modal-logo-google"
      />
      <h3>Please wait… </h3>
      <p>{showOTPsend} </p>
    </div>
  </div>

  
)}


        {showTermsModal && (
        <div className="bottomSlide-modal-overlay" style={{height:"75vh"}} onClick={() => setShowTermsModal(false)}>
          <div className="bottomSlide-modal" style={{position: "absolute"}} onClick={(e) => e.stopPropagation()}>

             <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setShowTermsModal(false)}
      >
        ×
      </button>

            <div className="modal-header-login">
              <h3>Terms & Conditions</h3>
              
            </div>
            <hr />
            <iframe
              src="/docs/PraSha-Sync-terms-of-use.html"
              title="Terms of Use"
              className="doc-frame"
              style={{height:"75%"}}

              ref={(el) => {
          if (el) {
            // Auto-scroll iframe content
            el.onload = () => {
              const iframeWindow = el.contentWindow;
              const iframeDoc = el.contentDocument || iframeWindow.document;
              const body = iframeDoc.body;

              let scrollStep = 1; // 1px per frame
              function autoScroll() {
                iframeWindow.scrollBy(0, scrollStep);
                if (
                  iframeWindow.scrollY + iframeWindow.innerHeight >=
                  body.scrollHeight
                ) {
                  //iframeWindow.scrollTo(0, 0); // reset to top
                }
                requestAnimationFrame(autoScroll);
              }

              setTimeout(() => {
          autoScroll();
        }, 2000);
            };
          }
        }}

              
            />
            {
              <button className="modal-close-btnlogin"  
              style={{display:"none"}}
              onClick={() => setShowTermsModal(false)}>
                Close
              </button>
            }
          </div>
        </div>
      )}

      {/* Privacy Modal */}
      
      {showPrivacyModal && (
  <div
    className="bottomSlide-modal-overlay"
    style={{height:"75vh"}}
    onClick={() => setShowPrivacyModal(false)}
  >
    <div
      className="bottomSlide-modal"
      style={{position: "absolute"}}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setShowPrivacyModal(false)}
      >
        ×
      </button>

      <div className="modal-header-login">
        <h3>PraSha Sync - Privacy Policy</h3>
      </div>
      <hr />

      <iframe
        src="/docs/PraSha-Sync-Privacy-Policy.html"
        title="Privacy Policy"
        className="doc-frame"
        style={{height:"75%"}}

        ref={(el) => {
          if (el) {
            // Auto-scroll iframe content
            el.onload = () => {
              const iframeWindow = el.contentWindow;
              const iframeDoc = el.contentDocument || iframeWindow.document;
              const body = iframeDoc.body;

              let scrollStep = 1; // 1px per frame
              function autoScroll() {
                iframeWindow.scrollBy(0, scrollStep);
                if (
                  iframeWindow.scrollY + iframeWindow.innerHeight >=
                  body.scrollHeight
                ) {
                  //iframeWindow.scrollTo(0, 0); // reset to top
                }
                requestAnimationFrame(autoScroll);
              }

              setTimeout(() => {
          autoScroll();
        }, 2000);
            };
          }
        }}



      />

      <button
        className="modal-close-btnlogin"
              style={{display:"none"}}
        onClick={() => setShowPrivacyModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}


 {showGoogleModal && (
        <div className="google-modal-overlay">
          <div className="google-modal-box">
            <h3>Signing in with Google...</h3>
            <p>Please complete the sign-in in the popup window.</p>
          </div>
        </div>
      )}


      </div>
    </div>
  );
}

export default LoginPage;
